module.exports = __webpack_public_path__ + "static/img/アセット 35@2x.98fadcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 35@2x.png
// module id = hzxP
// module chunks = 1